import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

/**
 * Human-readable labels for each route segment.
 * Add new routes here as they are created.
 */
const ROUTE_LABELS: Record<string, string> = {
  '': 'Home',
  shop: 'Shop',
  product: 'Product',
  cart: 'Cart',
  wishlist: 'Wishlist',
  search: 'Search',
  track: 'Track Order',
  about: 'About Us',
  contact: 'Contact Us',
  help: 'Help',
  press: 'Press',
  testimonials: 'Testimonials',
  blogs: 'Blog',
  articles: 'Articles',
  faq: 'FAQ',
  cancellation: 'Cancellation & Return',
  refund: 'Refund',
  'payment-options': 'Payment Options',
  terms: 'Terms & Conditions',
  'popular-search': 'Popular Searches',
  'best-deal': 'Best Deals',
  'industry-store': 'Industry Store',
  'find-b2b-buyers': 'Top Buying Requirement',
  checkout: 'Checkout',
  account: 'My Account',
  profile: 'Profile',
  orders: 'Orders',
  addresses: 'Addresses',
  business: 'Business Details',
  rfqs: 'My RFQs',
};

const Breadcrumb: React.FC = () => {
  const location = useLocation();

  // Don't show breadcrumb on home page
  if (location.pathname === '/') return null;

  const segments = location.pathname.split('/').filter(Boolean);

  // Build crumbs: always start with Home
  const crumbs: { label: string; path: string }[] = [
    { label: 'Home', path: '/' },
  ];

  let accumulated = '';
  segments.forEach((seg, i) => {
    accumulated += '/' + seg;
    const label = ROUTE_LABELS[seg] || seg.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    crumbs.push({ label, path: accumulated });
  });

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb" style={{ textAlign: 'left', width: '100%' }}>
      <div className="breadcrumb__container" style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <span key={crumb.path} className="breadcrumb__item">
              {index > 0 && <span className="breadcrumb__separator">›</span>}
              {isLast ? (
                <span className="breadcrumb__current">
                  {crumb.label === 'Home' && (
                    <svg className="breadcrumb__home-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                      <polyline points="9 22 9 12 15 12 15 22"/>
                    </svg>
                  )}
                  {crumb.label}
                </span>
              ) : (
                <Link to={crumb.path} className="breadcrumb__link">
                  {crumb.label === 'Home' && (
                    <svg className="breadcrumb__home-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                      <polyline points="9 22 9 12 15 12 15 22"/>
                    </svg>
                  )}
                  {crumb.label}
                </Link>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumb;
